import request from "./request";

const api = {
  getReceiveList: "user_wallet/getReceiveList",
  saveAddress: "user_wallet/saveAddress",
  withdraw: "user_wallet/withdraw",
  getWallet: "user_wallet/getWallet",
  getTransferList: "user_wallet/getTransferList",
  getWalletAddressList: "user_wallet/getWalletAddressList",
  delWalletAddress: "user_wallet/delWalletAddress",
};
export default {
  getReceiveList(parameter) {
    return request({
      url: api.getReceiveList,
      method: "POST",
      data: parameter,
    });
  },
  delWalletAddress(parameter) {
    return request({
      url: api.delWalletAddress,
      method: "POST",
      data: parameter,
    });
  },
  getWalletAddressList(parameter) {
    return request({
      url: api.getWalletAddressList,
      method: "POST",
      data: parameter,
    });
  },
  getTransferList(parameter) {
    return request({
      url: api.getTransferList,
      method: "POST",
      data: parameter,
    });
  },
  withdraw(parameter) {
    return request({
      url: api.withdraw,
      method: "POST",
      data: parameter,
    });
  },
  getWallet(parameter) {
    return request({
      url: api.getWallet,
      method: "POST",
      data: parameter,
    });
  },
  saveAddress(parameter) {
    return request({
      url: api.saveAddress,
      method: "POST",
      data: parameter,
    });
  },
};
